import { NavLink, useNavigate } from "react-router-dom";
import { useEffect } from "react";

function injectCSS(id, css) {
  if (document.getElementById(id)) return;
  const s = document.createElement("style");
  s.id = id;
  s.textContent = css;
  document.head.appendChild(s);
}

const TABS = [
  { to: "/sln-scan-live", label: "Live Screener", icon: "bi-activity" },
  { to: "/all-companies-stock", label: "All Companies", icon: "bi-table" },
  { to: "/oi-liner", label: "OI Liner", icon: "bi-graph-up" },
  {
    to: "/sector-strength",
    label: "Sector Strength",
    icon: "bi-bar-chart-line",
  },
];

function SLNScanHeader() {
  const navigate = useNavigate();

  useEffect(() => {
    injectCSS("sln-nav-css", CSS);
    try {
      const stored = localStorage.getItem("SLNUserDetails");
      const u = stored ? JSON.parse(stored) : null;
      if (u?.slnAccess === false) navigate("/dashboard", { replace: true });
    } catch {}
  }, [navigate]);

  return (
    <>
      {/* ── Desktop ── */}
      <nav className="sln-nav-bar d-none d-lg-block border-top">
        <div className="container">
          <div className="sln-nav-inner">
            {TABS.map((t) => (
              <NavLink
                key={t.to}
                to={t.to}
                className={({ isActive }) =>
                  "sln-nav-tab px-4 text-black" + (isActive ? " active" : "")
                }
              >
                <i className={`bi ${t.icon} tab-icon`} />
                {t.label}
              </NavLink>
            ))}
          </div>
        </div>
      </nav>

      {/* ── Mobile ── */}
      <div className="sln-nav-mobile d-lg-none">
        <div className="sln-nav-mobile-grid">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                "sln-nav-tab-mobile" + (isActive ? " active" : "")
              }
            >
              <i className={`bi ${t.icon}`} />
              {t.label}
            </NavLink>
          ))}
        </div>
      </div>
    </>
  );
}

export default SLNScanHeader;
